// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'; // Import Provider
import { HelmetProvider } from 'react-helmet-async';
import store from './store'; // Import Redux store
import App from './App';
import './i18n'; // initialise i18next before first render
import './fonts/nunito.css'; // self-hosted Nunito (@font-face) — no third-party font request

// Disable browser spell checking globally
if (typeof document !== 'undefined') {
    document.body.setAttribute('spellcheck', 'false');
}

// NOTE: GoogleOAuthProvider was removed from here. It injected the ~96 KiB
// accounts.google.com/gsi/client script on *every* page, but its only consumers
// (legacy LoginPage/SignUp) are no longer routed, and the modern sign-in/up
// pages have their Google button disabled. If Google login is re-enabled, wrap
// only the specific sign-in/sign-up route(s) so the script loads on demand.
ReactDOM.render(
    <HelmetProvider>
        <Provider store={store}>
            <App />
        </Provider>
    </HelmetProvider>,
    document.getElementById('root')
);